<template>
  <div class="item" :class='[isLast ? "last" : ""]' @click="onClick">
    <img src="../../assets/image/ic_select.png" class="check" v-if="isChecked"/>
    <span class="caption" :class='[isChecked ? "checked" : ""]'>{{item}}</span>
  </div>
</template>

<script>

export default {
  name: "MFSelectItem",
  props: [
    "item",
    "isChecked",
    "isLast",
  ],
  methods: {
    onClick() {
      this.$emit("click", this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/_vars.scss";

.item {
  position: relative;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eaeaea;
  cursor: pointer;
}

.last {
  border-bottom: none;
}

.check {
  widows: 20px;
  height: 20px;
  position: absolute;
  left: 20px;
}

.caption {
  color: black;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
}

.checked {
  color: $primary;
}

</style>



// WEBPACK FOOTER //
// src/components/controls/MFSelectItem.vue